import { useQuery } from '@tanstack/react-query';

import { organizationService } from '../services/organization.service';

export const useJurisdictions = () => {
  return useQuery({
    queryKey: ['jurisdictions'],
    queryFn: () => organizationService.getJurisdictions()
  });
};
